import React from 'react'
import PropTypes from 'prop-types'

import { List, Popup, Icon } from 'semantic-ui-react'

import { getFullPicturefilePath, hasPictureType } from 'Global/Helpers/rugHelpers'
import { buildText, buildPopupText } from './helpers'

const PictureCardPictureTypes = ({ picture, type }) =>
  hasPictureType(picture, type) ? (
    <List.Item>
      <a href={getFullPicturefilePath(picture, type)} download>
        <Popup content={buildPopupText(picture, type)} size="mini" trigger={<Icon name={'download'} />} />
        {buildText(picture, type)}
      </a>
    </List.Item>
  ) : null

PictureCardPictureTypes.propTypes = {
  picture: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
}

export default PictureCardPictureTypes
